<div class="dashboard-container">
    <!-- <iframe
        width="960"
        height="720"
        src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/236755227154/dashboards/b2fff9a4-2bca-4ef2-8b1c-e4a77162bc05?directory_alias=sizeo-demo"
    >
    </iframe> -->
    <h1 class="dashboard-header">Home</h1>

    <section class="dashboard-wrapper">
        <div class="tile-container">
            <div *ngFor="let category of $ApplicationSections[0]" [attr.hide]="!category?.is_favorite">
                <app-dashboard-tile [category]="category" *ngIf="category?.is_favorite"> </app-dashboard-tile>
            </div>
        </div>
    </section>
    <!-- <app-chat-wrapper></app-chat-wrapper> -->
</div>
